import {
  DropdownField,
  DropdownOptionItem,
  FieldTypes,
  TextField,
  ThreadType,
  UserGroup,
} from '@hb/shared'

export const newThreadTypeField: DropdownField = {
  placeholder: 'Thread Type',
  type: FieldTypes.DROPDOWN,
  options: [
    { text: 'Group Chat', id: ThreadType.GROUP },
    { text: 'Direct Message', id: ThreadType.DIRECT },
  ],
}

export const groupThreadTitleField: TextField = {
  placeholder: 'Thread Title',
  type: FieldTypes.TEXT,
}

export const practiceAccessLevelOptions: Array<DropdownOptionItem<UserGroup>> = [
  { text: 'HB Admins & Practice Members', id: 'practice' },
  { text: 'Shared with Patient', id: 'patient' },
]

export const adminAccessLevelOptions: Array<DropdownOptionItem<UserGroup>> = [
  { text: 'Hamilton Billing Admins', id: 'admin' },
  { text: 'HB Admins & Practice Members', id: 'practice' },
  { text: 'Shared with Patient', id: 'patient' },
]

export const practiceAccessLevelField: DropdownField = {
  placeholder: 'User Group',
  options: practiceAccessLevelOptions,
  type: FieldTypes.DROPDOWN,
}

export const adminAccessLevelField: DropdownField = {
  placeholder: 'User Group',
  options: adminAccessLevelOptions,
  type: FieldTypes.DROPDOWN,
}
